import React from 'react'
import { AppFormDrawer } from "@components"
import { clearDrawerData, userPayload } from "Pages/Admin/Users/@signals"
import { isEmpty } from "@ui-seeker/utils"
import { useComputed } from "@preact/signals-react"
import CreateUserDrawerContent from "Pages/Admin/Users/CreateDrawer/Content"
import UserCreateFooter from "Pages/Admin/Users/CreateDrawer/Content/Footer"


export default function CreateUserDrawer() {


	const isModalOpen = useComputed(() => !isEmpty(userPayload.value))

	if (!isModalOpen.value) return null

	const name = userPayload.peek().name

	return <AppFormDrawer
		icon={name ? 'user-pen' : 'user-plus'}
		title={name ? 'Edit user' : 'Create new User'}
		subtitle={name || 'New user'}
		width="100%"
		variant="persistent"
		isOpen={isModalOpen.value}
		controller={clearDrawerData}
		footer={<UserCreateFooter/>}
	>
		<CreateUserDrawerContent/>
	</AppFormDrawer>
}
